export default "__VITE_PUBLIC_ASSET__59ea01c3__"